import { h, createContext, ComponentChildren } from "preact";
import { useContext, useReducer } from "preact/hooks";
import { data } from "./demo";
import {ActionTypes, calculatorReducer} from "./reducer";
import {
  ServiceType,
  CalculatorsData,
  CalculatorState,
  CalculatorData,
} from "./types";

type CalculatorContext = {
  state: CalculatorState;
  dispatch: (action: ActionTypes) => void;
}

type ProviderProps = {
  children: ComponentChildren;
  serviceType: ServiceType;
}

const CalculatorContext = createContext<CalculatorContext | null>(null);
CalculatorContext.displayName = "CalculatorContext";

function getCalculatorData(
  dataObj: CalculatorsData,
  serviceType: ServiceType
): CalculatorData {
  return dataObj[serviceType];
}

function CalculatorProvider({ children, serviceType }: ProviderProps) {
  const initialState: CalculatorState = {
    serviceType: serviceType,
    serviceKits: getCalculatorData(data, serviceType).kits,
    currentVendors: [ ...getCalculatorData(data, serviceType).kits[0].vendors ], // NOTE: maybe indexes will be better choice
    currentVendor: getCalculatorData(data, serviceType).kits[0].vendors[0], // NOTE: maybe indexes will be better choice
    currentProducts: getCalculatorData(data, serviceType).kits[0].vendors[0].products, // NOTE: maybe indexes will be better choice
    serviceOptions: getCalculatorData(data, serviceType).kits[0].options,
    currentKitIndex: 0,
    currentVendorIndex: 0,
    productsSum: getCalculatorData(data, serviceType).kits[0].vendors[0].base_cost,
    optionsSum: getCalculatorData(data, serviceType).kits[0].subscription_min,
    setupSum: getCalculatorData(data, serviceType).kits[0].vendors[0].setup,
  }

  const [state, dispatch] = useReducer(calculatorReducer, initialState);

  const value: CalculatorContext = {
    state, dispatch
  };

  return (
    <CalculatorContext.Provider value={value}>{children}</CalculatorContext.Provider>
  );
}

function useCalculatorContext() {
  const context = useContext(CalculatorContext);
  if (context === undefined) {
    throw new Error(
      `"useCalculatorData" hook must be used only within "CalculatorProvider"`
    );
  }
  return context;
}

export { CalculatorProvider, useCalculatorContext, getCalculatorData };
